import {
    EventBus
} from '@/eventBus';

export default function (Vue) {
    const hasValidUserId = (userId) => {
        if (userId === null || typeof userId === 'undefined') {
            return false;
        }

        const normalizedUserId = String(userId).trim().toLowerCase();

        return normalizedUserId !== '' && normalizedUserId !== 'null' && normalizedUserId !== 'undefined';
    };

    const sanitizeCabinetLogToken = (value) => {
        if (value === null || typeof value === 'undefined') {
            return null;
        }

        return String(value)
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "_")
            .replace(/^_+|_+$/g, "") || null;
    };

    Vue.auth = {
        setToken(token, expiration = null) {
            localStorage.setItem('token', token);

            let nextExpiration = expiration;
            if (!nextExpiration) {
                let tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                nextExpiration = Math.round(+tomorrow / 1000);
            }

            localStorage.setItem('expiration', String(nextExpiration));
        },

        updateTokenExpiration(expiration) {
            if (!expiration || !localStorage.getItem('token')) {
                return;
            }

            localStorage.setItem('expiration', String(expiration));
        },

        setUser(username, type, userId) {
            localStorage.setItem('username', username);
            localStorage.setItem('type', type);

            if (hasValidUserId(userId)) {
                localStorage.setItem('user_id', String(userId));
                return;
            }

            localStorage.removeItem('user_id');
        },

        setRequestType(type) {
            localStorage.setItem('request_type', type)
        },

        getRequestType() {
           let type = localStorage.getItem('request_type');
           if (!type) {
               return null;
           }

           return type;
        },

        setSessionId(session_id) {
            document.cookie = `session_id=${session_id}`;
            localStorage.setItem('session_id', session_id);
        },

        getUser() {
            return {
                username: localStorage.getItem('username'),
                type: localStorage.getItem('type'),
                user_id: localStorage.getItem('user_id'),
            }
        },

        getToken() {
            let token = localStorage.getItem('token');
            let expiration = localStorage.getItem('expiration');

            if (!token || !expiration) return null;
            if (Math.round(new Date().getTime() / 1000) > expiration) {
                this.destroyToken("local_expired", {
                    expiration: Number(expiration) || null,
                    now: Math.round(new Date().getTime() / 1000),
                });
                return null;
            }

            return token;
        },

        destroyToken(reason = "unknown", details = {}) {
            const hadAuthState = Boolean(
                localStorage.getItem('token')
                || localStorage.getItem('expiration')
                || localStorage.getItem('request_type')
            );
            const normalizedReason = sanitizeCabinetLogToken(reason) || "unknown";
            const expiration = localStorage.getItem('expiration');
            const username = localStorage.getItem('username');
            const userId = localStorage.getItem('user_id');

            if (hadAuthState) {
                EventBus.$emit("cabinet-log", {
                    auth: {
                        expiration: expiration ? Number(expiration) || null : null,
                        reason: normalizedReason,
                        requestType: localStorage.getItem('request_type') || null,
                        tokenExists: Boolean(localStorage.getItem('token')),
                        ...details,
                    },
                    createdAt: new Date().toISOString(),
                    eventName: `auth.destroy_token.${normalizedReason}`,
                    orderId: null,
                    phoneState: null,
                    source: "auth",
                    userId: hasValidUserId(userId) ? String(userId) : null,
                    username: username || null,
                });
            }

            localStorage.removeItem('token');
            localStorage.removeItem('expiration');
            localStorage.removeItem('request_type')

            if (hadAuthState) {
                EventBus.$emit('logout-user');
            }
        },

        isAuthenticated() {
            return this.getToken() !== null;
        },
        getSessionId() {
            return localStorage.getItem('session_id');
        },
        hasAutoLoginParams(query) {
            return Object.keys(query).length !== 0 &&
                typeof query.username !== 'undefined' &&
                typeof query.api_token !== 'undefined';
        },
        isAutoLogin() {
            let urlParams = new URLSearchParams(window.location.search);
            return urlParams.has('username') &&
                urlParams.has('api_token') &&
                urlParams.has('api_token_expired');
        },
        isAutoLoginDoNotMatch() {
            const {
                username
            } = this.getUser();
            const token = localStorage.getItem('token');
            const expiration = localStorage.getItem('expiration');
            const urlParams = new URLSearchParams(window.location.search);

            return this.isAutoLogin() && (
                username !== urlParams.get('username') ||
                token !== urlParams.get('api_token') ||
                expiration !== urlParams.get('api_token_expired')
            )
        },
    };

    Object.defineProperties(Vue.prototype, {
        $auth: {
            get() {
                return Vue.auth;
            }
        }
    })
}
